var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { privateKey, setAssignAlias, extend, arrayUnion } from 'angular2-modal';
import { BSMessageModal } from '../message-modal.component';
import { BSModalContextBuilder } from '../modal-context';
var /** @type {?} */ DEFAULT_VALUES = {
    component: BSMessageModal,
    headerClass: 'modal-header',
    bodyClass: 'modal-body',
    footerClass: 'modal-footer'
};
var /** @type {?} */ DEFAULT_SETTERS = [
    'headerClass',
    'title',
    'titleHtml',
    'bodyClass',
    'footerClass'
];
/**
 * A Preset representing the configuration needed to open MessageModal.
 * This is an abstract implementation with no concrete behaviour.
 * Use derived implementation.
 * @abstract
 */
var MessageModalPresetBuilder = (function (_super) {
    __extends(MessageModalPresetBuilder, _super);
    /**
     * @param {?=} defaultValues
     * @param {?=} initialSetters
     * @param {?=} baseType
     */
    function MessageModalPresetBuilder(defaultValues, initialSetters, baseType) {
        if (defaultValues === void 0) { defaultValues = undefined; }
        if (initialSetters === void 0) { initialSetters = undefined; }
        if (baseType === void 0) { baseType = undefined; }
        var _this = _super.call(this, extend(extend({ buttons: [] }, DEFAULT_VALUES), defaultValues || {}), arrayUnion(DEFAULT_SETTERS, initialSetters || []), baseType) || this;
        setAssignAlias(_this, 'body', 'message', true);
        return _this;
    }
    /**
     * @param {?} css
     * @param {?} caption
     * @param {?} onClick
     * @return {?}
     */
    MessageModalPresetBuilder.prototype.addButton = function (css, caption, onClick) {
        var /** @type {?} */ btn = {
            cssClass: css,
            caption: caption,
            onClick: onClick
        };
        var /** @type {?} */ key = privateKey('buttons');
        ((this[key])).push(btn);
        return this;
    };
    return MessageModalPresetBuilder;
}(BSModalContextBuilder));
export { MessageModalPresetBuilder };
function MessageModalPresetBuilder_tsickle_Closure_declarations() {
    /**
     * A Class for the header (title) container.
     * Default: modal-header
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.headerClass;
    /**
     * Caption for the title, enclosed in a H3 container.
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.title;
    /**
     * HTML for the title, if set overrides title property.
     * The HTML is wrapped in a DIV element, inside the header container.
     * Example:
     * <div class="modal-header">
     * <div> HTML CONTENT INSERTED HERE </div>
     * </div>
     * Note: HTML is not compiled.
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.titleHtml;
    /**
     * aliased by 'body'
     * \@aliasedBy body
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.message;
    /**
     * The body of the modal.
     * Can be either text or HTML.
     * Note: When using HTML, the template is not compiled. (binding and expression will not parse)
     * \@aliasOf message
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.body;
    /**
     * A Class for the body container.
     * Default: modal-body
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.bodyClass;
    /**
     * A Class for the footer container.
     * Default: modal-footer
     * @type {?}
     */
    MessageModalPresetBuilder.prototype.footerClass;
}
//# sourceMappingURL=message-modal-preset.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/plugins/bootstrap/src/presets/message-modal-preset.js
// module id = 7
// module chunks = 0